var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M8.408 10v4.903M11.344 10v4.903M9.999 7.27h6.145l-.973 10.44a.872.872 0 0 1-.868.79H5.695a.872.872 0 0 1-.868-.79L3.854 7.27H10Zm0 0H16.444c.564 0 1.021-.416 1.021-.929V4.362c0-.513-.457-.929-1.021-.929h-3.939a.003.003 0 0 1-.003-.003M10 7.27H3.556c-.564 0-1.021-.416-1.021-.929V4.362c0-.513.457-.929 1.02-.929h3.94a.003.003 0 0 0 .002-.003m0 0 .108-1.072c.049-.483.494-.857 1.03-.858h2.729c.535 0 .982.372 1.031.856l.107 1.074m-5.005 0h-.356m.356 0h5.005m0 0h.357"
  })));
};
export default SvgTrash;